import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import Moment from 'moment'
import { extendMoment } from 'moment-range'
import getByPath from 'lodash/get'
import keyBy from 'lodash/keyBy'
import transform from 'lodash/transform'

const google = window.google

const moment = extendMoment(Moment)

const service = new google.maps.places.PlacesService(document.createElement('div'))

import { DEFAULT_PROFILE_PIC_SRC } from './../constants'

export function isObject (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

export const geoSuggestToLocation = geoSuggest => {
  const addressComponents = getByPath(geoSuggest, 'gmaps.address_components', [])

  const country = addressComponents.find(component => {
    return component.types.indexOf('country') === 0
  })

  const city = addressComponents.find(component => {
    return component.types.indexOf('locality') === 0
  })
  let description = getByPath(geoSuggest, 'description', '')
  if(description==""){
    description=getByPath(city, 'long_name', '') + getByPath(country, 'long_name', '')
  }
  

  return {
    city: getByPath(city, 'long_name', ''),
    cityWithDistrict: getByPath(city, 'long_name', ''),
    country: getByPath(country, 'long_name', ''),
    lat: getByPath(geoSuggest, 'location.lat', ''),
    lng: getByPath(geoSuggest, 'location.lng', ''),
    googleId: getByPath(geoSuggest, 'placeId', ''),
    description: description
  }
}

export function locationToGeoSuggest (location) {
  const { cityWithDistrict, country, city, description, lat, lng, googleId } = location
  return {
    description,
    placeId: googleId,
    gmaps: {
      address_components: [
        {
          long_name: city,
          types: ['locality']
        },
        {
          long_name: cityWithDistrict
            .split(', ')
            .slice(1)
            .join(', '),
          types: ['region']
        },
        {
          long_name: country,
          types: ['country']
        }
      ]
    },
    location: {
      lat,
      lng
    }
  }
}

export function getLatLngByAddress (address) {
  const result = {}

  return geocodeByAddress(address)
    .then(results => {
      if (Array.isArray(results)) {
        result.additionalInfo = results[0]
        return getLatLng(results[0])
      } else {
        return Promise.reject()
      }
    })
    .then(center => ({
      ...result,
      center
    }))
}

export function enumerateDaysBetweenDates (startDate, endDate) {
  const start = moment(startDate).startOf('day')
  const end = moment(endDate).startOf('day')

  return Array.from(moment.range(start, end).by('day'))
}

export function get15MinsIntervals (t) {
  const result = []

  for (let i = 15; i <= 24 * 60; i += 15) {
    let hours = Math.floor(i / 60)
    let minutes = i % 60
    let str = ''

    if (hours > 0) {
      if (hours === 1) {
        str += hours + ' ' + (t ? t('main:hour') : 'Hour') + ' '
      }
      else {
        str += hours + ' ' + (t ? t('main:hours') : 'Hours') + ' '       
      }
    }

    if (minutes > 0) {
      str += minutes + ' ' + (t ? t('main:minutes') : 'Minutes')
    }

    result.push({
      label: str,
      value: i
    })
  }

  return result
}

export const getPlaceInfoById = placeId =>
  new Promise((resolve, reject) => {
    service.getDetails({ placeId }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(place)
      } else {
        resolve()
      }
    })
  })

export const getPlaceInfoByAddress = query =>
  new Promise((resolve, reject) => {
    service.textSearch({ query }, (place, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(place[0])
      } else {
        resolve()
      }
    })
  })

export function getUserImage (user) {
  const imageAvatar = getByPath(user, 'userProfile[0].imageAvatar.s3Url')

  if (imageAvatar) {
    return imageAvatar
  } else {
    const userImage = window.localStorage.getItem('userImage')

    if (userImage) {
      return userImage
    } else {
      return DEFAULT_PROFILE_PIC_SRC
    }
  }
}

export function getLanguageOptions() {
  return [
    {
      label: 'English',
      value: 'en'
    },
    {
      label: 'Deutch',
      value: 'de'
    },
    {
      label: 'עברית',
      value: 'he',
    }
  ]
}


/**
 * @param {Object} obj
 * @param {Array<String>} keysToOmit
 * @return {Object}
 */
export const deepOmit = (obj, keysToOmit) => {
  const keysToOmitIndex = keyBy(keysToOmit)

  const omitFromObject = obj => {
    return transform(obj, (result, value, key) => {
      if (key in keysToOmitIndex) return

      result[key] = isObject(value) || Array.isArray(value) ? omitFromObject(value) : value
    })
  }

  return omitFromObject(obj)
}

export const getDurationView = (start, end, t) => {

  let durationView
  let duration
  if (start && end) {
    const startDate = moment(start)
    const endDate = moment(end)
    duration = endDate.diff(startDate, 'minutes')
    const days = parseInt(duration / 1440)
    const reminderDays = duration - days * 1440
    const hours = parseInt(reminderDays / 60)
    const minutes = reminderDays - hours * 60
    durationView = ''
    if (days > 0) {
      durationView += days + ' ' + (days == 1 ? t('one_day') : t('days')) + ' '
    }
    if (hours > 0) {
      durationView += hours + ' ' + (hours == 1 ? t('one_hour') : t('hours')) + ' '
    }
    if (minutes > 0) {
      durationView += minutes + ' ' + (minutes == 1 ? t('one_minute') : t('minutes')) + ' '
    }
  }
  return durationView
}




// WEBPACK FOOTER //
// src/libs/utils.js